var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#7DCFED}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_647606624"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M11984002 6031999c0,-96000 -37335,-170669 -112004,-223996l-3679998 -2848005c-106665,-85335 -223996,-85335 -352004,0l-3552002 2848005c-63992,53327 -96000,127996 -96000,223996l0 5136003c0,85406 26669,154665 80008,208004 53327,53327 117331,80079 192000,80079l2112001 0c85335,0 154665,-26693 207992,-80079 53339,-53339 80008,-122598 80008,-208004l0 -3151974 2431997 0 0 3151939c0,85417 26669,154677 79996,208004 53339,53339 122669,80079 208004,80079l2112001 12c85335,0 154665,-26693 208004,-80079 53327,-53386 79996,-122598 79996,-208004l0 -5135979zm-3984002 -6032011c1098662,0 2136001,210673 3112005,632008 975993,421335 1824001,991997 2544001,1711997 720000,720000 1290662,1568009 1711997,2544001 421335,976004 632008,2013344 632008,3112005 0,736004 -96000,1445339 -288000,2128005 -192083,682583 -461339,1319918 -808004,1911993 -346666,592004 -762674,1130670 -1248001,1616009 -485280,485327 -1024004,901406 -1616009,1248001 -592051,346666 -1229327,616004 -1912052,808004 -682607,192000 -1391942,288000 -2127946,288000 -736004,0 -1445339,-96000 -2128005,-288000 -682666,-192083 -1320001,-461339 -1911993,-808004 -592004,-346666 -1130670,-762674 -1616009,-1248001 -485327,-485280 -901335,-1024004 -1248001,-1616009 -346666,-592051 -616004,-1229327 -808004,-1912017 -192000,-682642 -288000,-1391977 -288000,-2127981 0,-736004 96000,-1445339 288000,-2128005 192000,-682666 461339,-1320001 808004,-1911993 346666,-592004 762674,-1130670 1248001,-1616009 485339,-485327 1024004,-901335 1616009,-1248001 591992,-346666 1229327,-616004 1911993,-808004 682666,-192000 1392001,-288000 2128005,-288000z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.de76d2cf97801067447a8dc26993da8d.svg";
export { ForwardRef as ReactComponent };